<?xml version="1.0" encoding="UTF-8"?>
<svg width="7px" height="4px" viewBox="0 0 7 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>DropDown</title>
    <g id="Episode-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Disco-Play,-Additional-Follow-Buttons:-prompt-(SPAR-19473)-Copy-8" transform="translate(-654, -885)" fill="currentColor" fill-rule="nonzero">
            <g id="Components/-Dropdown/-Dark/-Default" transform="translate(437, 862)">
                <path d="M217.58875,23 L223.41125,23 C223.934786,23 224.196554,23.6201736 223.827143,23.981742 L220.915893,26.8311883 C220.685929,27.0562706 220.314071,27.0562706 220.086554,26.8311883 L217.172857,23.981742 C216.803446,23.6201736 217.065214,23 217.58875,23 Z" id="DropDown"></path>
            </g>
        </g>
    </g>
</svg>